import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DuracioncursosService {

  url = environment.apiURL + 'sgc/grupos/cuotas';

  constructor(private http: HttpClient) { }

  duracionCurso(id): Observable<any> {
    const url = this.url+ '/' + id;
    return this.http.get<any>(url);
  }
}
